import React, { useEffect, useState, useRef } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import { RefreshCw } from "lucide-react";

const VersionWatcher = () => {
  const [showModal, setShowModal] = useState(false);
  const intervalRef = useRef(null);

  const checkVersion = async () => {
    if (document.hidden) return;

    try {
      const res = await fetch("/version.json?_=" + Date.now(), {
        cache: "no-store",
      });
      const data = await res.json();
      const current = window.APP_VERSION;

      if (data.version && current && data.version !== current) {
        setShowModal(true);
      }
    } catch (err) {
      console.error("Version check failed:", err);
    }
  };

  useEffect(() => {
    checkVersion();
    intervalRef.current = setInterval(checkVersion, 60000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const reloadPage = () => window.location.reload(true);

  return (
    <Modal isOpen={showModal} centered fade className="koru-update-modal">
      <ModalBody className="p-4 text-center">
        {/* Icon */}
        <div className="d-flex justify-content-center mb-3">
          <div className="koru-icon-wrap">
            <RefreshCw size={32} className="koru-icon" />
          </div>
        </div>

        <h4 className="koru-title">New Version Available</h4>

        <p className="koru-desc">
          A new update is available. Refresh the page to apply the latest
          changes.
        </p>

        <div className="mt-4 d-flex justify-content-center gap-3">
          {/* <Button
            className="koru-btn-cancel"
            onClick={() => setShowModal(false)}
          >
            Later
          </Button> */}
          <Button className="koru-btn-update" onClick={reloadPage}>
            Refresh Now
          </Button>
        </div>
      </ModalBody>

      <style>{`
        /* container */
        .koru-update-modal .modal-content {
          background: linear-gradient(180deg, #ffffff 0%, #f4f7fa 100%);
          border-radius: 16px;
          border: 1px solid rgba(0,0,0,0.08);
          box-shadow: 0 12px 32px rgba(0,0,0,0.12);
          animation: koruLightFade 0.25s ease-out;
        }

        @keyframes koruLightFade {
          from { opacity: 0; transform: translateY(8px) scale(0.97); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }

        /* Icon background */
        .koru-icon-wrap {
          background: rgba(77, 166, 255, 0.15);
          border: 1px solid rgba(77, 166, 255, 0.25);
          padding: 16px;
          border-radius: 14px;
        }

        .koru-icon {
          color: #0d6efd;
        }

        /* Title */
        .koru-title {
          color: #0d1117;
          font-weight: 600;
          letter-spacing: 0.2px;
        }

        /* Description */
        .koru-desc {
          color: #4a5568;
          font-size: 15px;
          margin-top: 8px;
        }

        /* Buttons */
        .koru-btn-cancel {
          background: #e8ecf1 !important;
          border: none !important;
          color: #3a3f45 !important;
          padding: 8px 20px !important;
          border-radius: 8px !important;
          font-weight: 500;
        }

        .koru-btn-update {
          background: #556ee6 !important;
          border: none !important;
          padding: 8px 22px !important;
          border-radius: 8px !important;
          color: white !important;
          font-weight: 600;
        }

        .koru-btn-update:hover {
          background: #3f8bff !important;
        }
      `}</style>
    </Modal>
  );
};

export default VersionWatcher;
